import { useCallback, useState } from 'react'
import api from '../../../../../../services/api'
import { OrderItem } from './useOrderCart'

interface AddressData {
  zipcode: string
  street: string
  number: string
  complement: string
  neighborhood: string
  city: string
  state: string
  is_discrete_shipping?: boolean
}

interface CustomerData {
  name: string
  cpf: string
  birth_date: string
  phone: string
  email: string
}

interface CheckoutPayload {
  documents: boolean
  recipes: (null | any)[]
  shippingAddress: {
    cep: string
    street: string
    address_number: string
    complement: string
    district: string
    city: string
    state: string
    country: string
    is_discrete_shipping?: boolean
  }
  billingAddress: {
    cep: string
    street: string
    number: string
    complement: string
    neighborhood: string
    city: string
    state: string
    country: string
  }
  items: Array<{
    product_id: number
    quantity: number
    type: string
    brand_id: number
    class_id: number
    unitPrice: string
    discount: string
    amount: string
    promotional: boolean
    promotion_id?: number | null
  }>
  customer: {
    name: string
    surname: string
    email: string
    cpf: string
    birth_date: string
    phone: string
  }
  utmParams: {
    utm_source: string
    utm_medium: string
    utm_campaign: string
    utm_term: string
    utm_content: string
  }
  ga_client_id: string
  ga_session_id: string
}

interface UseCheckoutReturn {
  loading: boolean
  error: string | null
  submitCheckout: (orderId: number, address: AddressData, items: OrderItem[], customer: CustomerData) => Promise<void>
}

export const useCheckout = (): UseCheckoutReturn => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const submitCheckout = useCallback(
    async (orderId: number, address: AddressData, items: OrderItem[], customer: CustomerData) => {
      setLoading(true)
      setError(null)

      try {
        const payload: CheckoutPayload = {
          documents: false,
          recipes: [null],
          shippingAddress: {
            cep: address.zipcode,
            street: address.street,
            address_number: address.number,
            complement: address.complement || '',
            district: address.neighborhood,
            city: address.city,
            state: address.state,
            country: 'Brasil',
            is_discrete_shipping: address.is_discrete_shipping ?? false
          },
          billingAddress: {
            cep: '',
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            city: '',
            state: '',
            country: ''
          },
          items: items.map((item) => ({
            product_id: item.product_id,
            quantity: item.quantity,
            type: item.type,
            brand_id: item.product.brand_id,
            class_id: item.product.class_id,
            unitPrice: item.unitPrice,
            discount: item.discount,
            amount: item.amount,
            promotional: item.promotional,
            promotion_id: item.promotion_id || null
          })),
          customer: {
            name: customer.name || '',
            surname: '',
            email: customer.email || '',
            cpf: customer.cpf || '',
            birth_date: customer.birth_date || '',
            phone: customer.phone || ''
          },
          utmParams: {
            utm_source: '',
            utm_medium: '',
            utm_campaign: '',
            utm_term: '',
            utm_content: ''
          },
          ga_client_id: '',
          ga_session_id: ''
        }

        const response = await api.put(`/order_cart/${orderId}`, payload)

        if (response.data.success) {
          // Checkout successful
        }
      } catch (err: any) {
        console.error('Error submitting checkout:', err)
        setError('Erro ao finalizar compra.')
        throw err
      } finally {
        setLoading(false)
      }
    },
    []
  )

  return {
    loading,
    error,
    submitCheckout
  }
}
